import React from 'react';
import { Package } from 'lucide-react';

/**
 * Header component for Wholesale Inventory Separation Dashboard
 * Displays title, subtitle, and placeholder for facility picker
 */
export function InventorySeparationHeader() {
    return (
        <div className="bg-white border-b border-gray-200 w-full px-6">
            <div className="px-12 py-4">
                <div className="flex items-center justify-between">
                    {/* Left side - Title and subtitle */}
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center">
                            <Package className="w-5 h-5 text-blue-700" />
                        </div>
                        <div>
                            <h1 className="text-xl font-semibold text-gray-900">Inventory Management System</h1>
                            <p className="text-sm text-gray-500">Budget Allocation & Forecasting by Facility</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
